import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { AppStore } from '../../common/stores/app.store';

@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.scss']
})

export class SetupComponent implements OnInit {

  hasErrors = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: AppStore) { }

    ngOnInit() {
      // const next = this.next();
      const next = ['/frames'];
      if (next) {
        this.navigate(next);
      } else {
        this.hasErrors = true;
      }

      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          console.log('NavigationEnd:', event);
        }
      });

      // get param
      // const param1 = this.route.snapshot.queryParams['eventId'];
      // console.log(param1);
    }

    next(): Array<string> {
      const eventId = this.store.eventId;
      const roomId = this.store.roomId;
      const companyToken = this.store.companyToken;

      if (eventId && roomId && companyToken) {
        // this.router.navigate(['/rooms', this.store.roomId]);
        return ['/frames', this.store.roomId];
      }

      if (eventId && companyToken) {
        return ['/rooms'];
      }

      return null;
    }

    navigate(target: Array<string>) {
      this.router.navigate(target, { queryParamsHandling: 'preserve' });
    }
}
